module.exports = __webpack_public_path__ + "static/elkabetz-hex-cb78af1793bacc42e9992b19888319a7.png";